// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"f56cb37f7e6bba3f","734":"38f4a643d31da5ef","894":"a3e464db6f546bfd","936":"bdc4ba116f72647b"}[chunkId] + ".js";
};